import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Opresión en el pecho por ansiedad: cuándo preocuparse?",
    answer:
      "La opresión o molestia en el pecho puede deberse a ansiedad, pero también a causas médicas que requieren atención urgente. Si tiene dolor torácico, dificultad para respirar o síntomas nuevos, busque atención médica inmediata. Para síntomas de salud mental, una consulta con el equipo clínico puede ayudar.",
  },
];

export const esAnxietyChestTightness = makeEsArticle({
  slug: "anxiety-chest-tightness-when-to-worry",
  title: "Opresión en el pecho por ansiedad: cuándo preocuparse",
  description:
    "La opresión en el pecho puede deberse a ansiedad, pero también a causas médicas. Si tiene dolor torácico o dificultad para respirar, busque atención médica inmediata.",
  h1: "Opresión en el pecho por ansiedad: cuándo preocuparse",
  breadcrumbLabel: "Opresión en el pecho por ansiedad",
  shortAnswer:
    "La opresión o molestia en el pecho puede deberse a la ansiedad, pero también puede ser señal de un problema médico que requiere atención urgente. Si tiene dolor torácico, dificultad para respirar o síntomas nuevos, busque atención médica inmediata. Una vez descartadas las causas médicas, si los síntomas de ansiedad persisten, una consulta con el equipo clínico puede ayudar a evaluar opciones. SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos, no para la ansiedad.",
  keyTakeaways: [
    "La opresión en el pecho puede deberse a ansiedad o a causas médicas.",
    "El dolor torácico o la dificultad para respirar requieren atención médica inmediata.",
    "Descarte primero las causas médicas.",
    "Para síntomas de salud mental persistentes, consulte al equipo clínico.",
    "SAINT® no está indicada para la ansiedad.",
  ],
  sections: [
    {
      heading: "Importante: descartar causas médicas",
      paragraphs: [
        "El dolor o la opresión en el pecho pueden ser señales de un problema cardíaco o pulmonar que requiere atención urgente. Si experimenta dolor torácico, dificultad para respirar o síntomas nuevos, busque atención médica inmediata. No asuma que es ansiedad sin una evaluación médica.",
      ],
    },
    {
      heading: "Cuando la causa es la ansiedad",
      paragraphs: [
        "Una vez descartadas las causas médicas, si los síntomas de ansiedad persisten, una consulta con el equipo clínico puede ayudar a revisar el plan de tratamiento. SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos; no está indicada para la ansiedad.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
